import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {FieldConfigName} from '../../../../models';

@Component({
  selector: 'app-choice-list',
  templateUrl: './choice-list.component.html',
  styleUrls: ['./choice-list.component.scss']
})
export class ChoiceListComponent implements OnInit {
  @ViewChild('suppField') suppFieldElement: ElementRef;
  @Input() control: FieldConfigName;
  @Output() fieldChoiceList = new EventEmitter<{ key: string }[]>();

  editFieldInputForm: UntypedFormGroup;
  fieldsLimit: number;
  formArray: UntypedFormArray;

  constructor(private formBuilder: UntypedFormBuilder,) { }

  ngOnInit(): void {
    this._buildFormBuilder();
    this._initFormBuilder();
  }

  private _buildFormBuilder() {
    this.editFieldInputForm = this.formBuilder.group({
      choices: this.formBuilder.array([]),
      suppField: ['', []],
      choices_text: ['', []],
    });
  }

  private _initFormBuilder() {
    this._setChoicesFromCks();
  }

  private _setChoicesFromCks(): void {
    this.formArray = this.editFieldInputForm.get('choices') as UntypedFormArray;
    const choices_concat: Array<String> = [];
    this.control.options.options.forEach(choice => {
      if (typeof choice !== 'string') {
        this.formArray.push(new UntypedFormGroup({
          key: new UntypedFormControl(choice.key),
        }));
        choices_concat.push(choice.key.toString());
      }
    });
    this.editFieldInputForm.setValue({
      choices: this.formArray.value,
      suppField: null,
      choices_text: choices_concat.join('\n'),
    });
  }

  sendChoices() {
    // TODO: Utiliser autre chose que focusout ?
    // Appeler lors de:
    // - focusout input (tab1)
    // - add field (tab1)
    // - del field (tab1)
    // - focusout textarea (tab2)

    // Maj liste textearea
    this.updateListFromChoices();
    // Force maj depuis la liste texte, pour enlever les entrée vide
    this.updateChoicesFromList();
    this.fieldChoiceList.emit(this.editFieldInputForm.get('choices').value);
  }

  updateChoicesFromList() {
    // Appeler lors de changement dans le textarea
    // avant tout focusout et donc de sendChoices
    this.formArray.clear();
    this.editFieldInputForm.get('choices_text').value.trim().split('\n').forEach((_choice) => {
      const clean_choice = _choice.trim();
      if (clean_choice) { // Enlever les choix vides
        this.formArray.push(new UntypedFormGroup({
          key: new UntypedFormControl(clean_choice),
        }));
      }
    });
  }

  updateListFromChoices() {
    // Appeler par sendChoices
    const choices_concat: Array<String> = [];
    this.formArray.value.forEach ( (_choice) => {
      const clean_choice = _choice.key.toString().trim();
      if (clean_choice) { // Enlever les choix vides
        choices_concat.push(clean_choice);
      }
    });
    this.editFieldInputForm.patchValue({choices_text: choices_concat.join('\n')});
  }

  addField(): void {
    this.formArray.push(new UntypedFormGroup({
      key: new UntypedFormControl(this.editFieldInputForm.get('suppField').value),
    }));
    this.editFieldInputForm.patchValue({suppField: null});
    this.suppFieldElement.nativeElement.focus();
    this.sendChoices();
  }

  removeField(index: number): void {
    this.formArray.removeAt(index);
    this.sendChoices();
  }
}
